export default __webpack_public_path__ + "static/media/designLogo.87f1ce32.png";